import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const createPledge = ({ churchId, campaignId, pledgeData }) => {
  return axios.post(
    `/churches/${churchId}/campaigns/${campaignId}/pledges`,
    pledgeData
  );
};

export const useCreatePledge = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("pledges-paginated");

      setNotification({
        type: "success",
        message: "Pledge created successfully!"
      });
    },
    ...config,
    mutationFn: createPledge
  });
};
